// The purpose of this helper is either open, close or lock computer screens on demand
// This helper is initialized in assetsManager after flat   .glb is loaded.
import {getGameSounds} from "../babylonScene"

const computerScreens = (() => {

  let flatOpen, warehouseOpen, bunkerOpen, flatClosed, warehouseClosed, bunkerClosed, warehouseLocked, bunkerLocked;

  return {
    init: scene => {
        flatOpen = scene.getMeshByName("H1_Naytto_email_auki") || {setEnabled: () => null};
        warehouseOpen = scene.getMeshByName("H2_Naytto_auki") || {setEnabled: () => null};
        bunkerOpen = scene.getMeshByName("H3_naytto_auki") || {setEnabled: () => null};
      
        flatClosed = scene.getMeshByName("H1_Naytto_email_kiinni") || {setEnabled: () => null};
        warehouseClosed = scene.getMeshByName("H2_naytto_kiinni") || {setEnabled: () => null};
        bunkerClosed = scene.getMeshByName("H3_naytto_kiinni") || {setEnabled: () => null};
      
        warehouseLocked = scene.getMeshByName("H2_Naytto_lukittu") || {setEnabled: () => null};
        bunkerLocked = scene.getMeshByName("H3_naytto_lukittu") || {setEnabled: () => null};
    },
    warehouse: {
      lock: () => {
        warehouseLocked.setEnabled(true);
        warehouseClosed.setEnabled(false);
        warehouseOpen.setEnabled(false);
        scene.getSoundByName("warehouseComputerSound")?.dispose()
      },
      close: () => {
        warehouseLocked.setEnabled(false);
        warehouseClosed.setEnabled(true);
        warehouseOpen.setEnabled(false);
      },
      open: () => {
        warehouseLocked.setEnabled(false);
        warehouseClosed.setEnabled(false);
        warehouseOpen.setEnabled(true);
        scene.getSoundByName("warehouseComputerSound")?.play()
      },
      availableToUse: () => { return scene.getMeshByName("H2_Naytto_auki") ? scene.getMeshByName("H2_Naytto_auki").isEnabled() : false}
    },
    bunker: {
      lock: () => {
        bunkerLocked.setEnabled(true);
        bunkerClosed.setEnabled(false);
        bunkerOpen.setEnabled(false);
        scene.getSoundByName("bunkerComputerSound")?.dispose()
      },
      close: () => {
        bunkerLocked.setEnabled(false);
        bunkerClosed.setEnabled(true);
        bunkerOpen.setEnabled(false);
      },
      open: () => {
        bunkerLocked.setEnabled(false);
        bunkerClosed.setEnabled(false);
        bunkerOpen.setEnabled(true);
        scene.getSoundByName("bunkerComputerSound")?.play()
      },
      availableToUse: () => { return scene.getMeshByName("H3_naytto_auki") ? scene.getMeshByName("H3_naytto_auki").isEnabled() : false}
    },
    flat: {
      close: () => {
        flatClosed.setEnabled(true);
        flatOpen.setEnabled(false);
      },
      open: () => {
        flatClosed.setEnabled(false);
        flatOpen.setEnabled(true);
        scene.getSoundByName("flatComputer2Sound")?.play()
      },
      availableToUse: () => { return scene.getMeshByName("H1_Naytto_email_auki") ? scene.getMeshByName("H1_Naytto_email_auki").isEnabled() : false}
    },
  };
})();

export {computerScreens}
